<script>
    import MerchRequestForm from "./MerchRequestForm.svelte";

    async function getMerch() {
        const res = await fetch("/api/merch");

        if (res.ok) {
            const json = await res.json();
            return json;
        } else {
            throw new Error("couldn't load merch");
        }
    }

    let promise = getMerch();

    let open = {};
</script>

<div class="min-h-[500px]">
    {#await promise}
        <div class="text-fuschia-400">Loading!</div>
    {:then value}
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
            {#each value as mer, i (i)}
                <div>
                    <div
                        class="card rounded-none border-2 border-fuchsia-400"
                    >
                        <figure class="p-4 h-64">
                            <img
                                class="max-w-full max-h-full w-full h-full object-contain bg-neutral-focus border-2 border-fuchsia-400 shadow-md shadow-black"
                                alt=""
                                src={mer.image}
                            />
                        </figure>

                        <div class="p-4 flex flex-row justify-between">
                            <div>
                                <h2 class="card-title m-0">
                                    {mer.title}
                                </h2>
                                <p class="font-thin">
                                    {mer.status} -- {mer.price}€
                                </p>
                            </div>
                            <a
                                on:click={() => {
                                    open[mer.id] = !open[mer.id];
                                }}
                            >
                                <button class="p-2 bg-fuchsia-400 cursor-pointer"
                                >
                                    {#if open[mer.id]}
                                        X
                                    {:else}
                                        Με ενδιαφέρει
                                    {/if}
                                </button
                                >
                            </a>
                        </div>

                        <div class="p-4">
                            {@html mer.description}
                        </div>
                    </div>

                    {#if open[mer.id]}
                        <MerchRequestForm merch={mer} />
                    {/if}
                </div>
            {/each}
        </div>
    {:catch error}
        <div class="alert alert-error">
            <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="stroke-current flex-shrink-0 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    ><path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    /></svg
                >
                <span>Error: {error.message}</span>
            </div>
        </div>
    {/await}
</div>
